import { type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'

function LoadingScreen() {
    return (
        <div
            data-testid="loading-screen"
            className="min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark"
        >
            <div className="text-center">
                <img
                    src="/assets/logo.png"
                    alt="Loading"
                    className="w-16 h-16 mx-auto mb-4 animate-pulse brightness-0 dark:invert"
                />
                <p className="text-text-secondary-light dark:text-text-secondary-dark">
                    Loading...
                </p>
            </div>
        </div>
    )
}

export function AdminRoute({ children }: { children: ReactNode }) {
    const { isAuthenticated } = useAuth()
    const { isAdmin, isLoading } = useFeatureFlags()

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />
    }

    if (isLoading) {
        return <LoadingScreen />
    }

    if (!isAdmin) {
        return <Navigate to="/settings" replace />
    }

    return <>{children}</>
}
